import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class VizsgaFeladatsorEditDto extends IdentifiableDto {
	/**
	 * @module VizsgaFeladatsorEditDto
	 */
	constructor() {
		super();
		/** @type {number} */
		this.vizsgaVizsgasor = null;
		/** @type {number} */
		this.feladatgyujtemenyId = null;
		/** @type {number[]} */
		this.genParamIdList = null;
	}

	/**
	 * @typedef {Object} _VizsgaFeladatsorEditDtoProps
	 * @property {number} vizsgaVizsgasor
	 * @property {number} feladatgyujtemenyId
	 * @property {number[]} genParamIdList
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _VizsgaFeladatsorEditDtoProps} VizsgaFeladatsorEditDtoProps
	 */
	/**
	 *
	 * @param {VizsgaFeladatsorEditDtoProps} props
	 * @returns {VizsgaFeladatsorEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.vizsgaVizsgasor = props.vizsgaVizsgasor;
		this.feladatgyujtemenyId = props.feladatgyujtemenyId;
		this.genParamIdList = props.genParamIdList;
		return this;
	}
}

export default VizsgaFeladatsorEditDto;
